<template>
  <div class="bg-white-900 mb-14 mt-2">
    <div class="container mx-auto">
      <h1 class="sr-only">Catalog details</h1>
      <!-- catalog info block -->
      <base-breadcrumbs :links-list="breadcrumbsList" class="mb-6" />
      <card-catalog-detail @export-to-pdf="exportToPdf" class="mb-9" />
      <actions-bar
        select-type="books"
        title="Books total: 35"
        title-class="text-2xl"
        placeholder="Search by name, author, ISBN"
      />
      <list-books :show-publishers="false" class="mb-13" />
    </div>
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        filename="Catalog"
        :paginate-elements-by-height="1060"
        :manual-pagination="false"
        pdf-content-width="775px"
        ref="booksHtml2Pdf"
        :html-to-pdf-options="htmlToPdfOptions"
      >
        <books-pdf slot="pdf-content" :books-list="booksArray" />
      </vue-html2pdf>
    </div>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";

import ActionsBar from "@/components/base/ActionsBar.vue";
import CardCatalogDetail from "@/components/cards/CardCatalogDetail.vue";
import TabBooks from "@/components/tabs/Books.vue";
import Breadcrumbs from "@/components/base/Breadcrumbs.vue";
import BooksPdf from "@/components/pdf/BooksList.vue";

export default {
  name: "CatalogPage",
  components: {
    VueHtml2pdf,
    "card-catalog-detail": CardCatalogDetail,
    "actions-bar": ActionsBar,
    "list-books": TabBooks,
    "base-breadcrumbs": Breadcrumbs,
    "books-pdf": BooksPdf,
  },
  data() {
    return {
      booksArray: [
        {
          id: 1,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/1.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: false,
          price: 12.0,
        },
        {
          id: 2,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/2.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 3,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/3.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: false,
          price: 12.0,
        },
        {
          id: 4,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/4.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 5,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/5.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 6,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/6.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
        {
          id: 7,
          name: "My BFF Is an Alien: Turbulence",
          imageURl: require("@/assets/books/7.jpg"),
          catalogTitles: 15,
          author:
            "CHERYL JULIA LEE (ED.), CHRISTINE CHIA (ED.), JOSHUA IP (ED.)",
          imprint: "Amicus Inc",
          isbn: "9789811809002",
          pubDate: "June 22, 2020",
          isAvailable: true,
          price: 12.0,
        },
      ],
      value: [0, 100],
      modal: {
        data: {},
      },
      breadcrumbsList: [
        {
          href: "/catalogs",
          text: "Сatalogs",
        },
        {
          href: "/publishers/1/",
          text: "Epigram Bookshop",
        },
        {
          href: "/catalogs/1/",
          text: "The Keepers of Stories",
        },
      ],
      htmlToPdfOptions: {
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          scale: 5,
        },
        margin: [5, 0, 0, 0],
        jsPDF: {
          format: "a4",
          orientation: "portrait",
        },
      },
    };
  },
  methods: {
    exportToPdf() {
      this.$refs.booksHtml2Pdf.generatePdf();
    },
  },
};
</script>
